import React from 'react';
import { Icon } from './Icon.js';
export const IconMedicalCross2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 10L10 7H14L14 10H17L17 14H14L14 17H10L10 14H7.00001L7 10H10Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMedicalCross2.js.map